// extracted by mini-css-extract-plugin
export default {"closeButton":"_3ek8","static":"_1zHa"};